import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { env } from '@/config/environment';

import enCommon from './en/common.json';
import enAuth from './en/auth.json';
import enBooking from './en/booking.json';
import enPricing from './en/pricing.json';
import enValidation from './en/validation.json';
import enWallet from './en/wallet.json';
import enNotification from './en/notification.json';
import enHome from './en/home.json';
import enRoutes from './en/routes.json';
import enRental from './en/rental.json';

import rwCommon from './rw/common.json';
import rwAuth from './rw/auth.json';
import rwBooking from './rw/booking.json';
import rwPricing from './rw/pricing.json';
import rwValidation from './rw/validation.json';
import rwWallet from './rw/wallet.json';
import rwNotification from './rw/notification.json';
import rwHome from './rw/home.json';
import rwRoutes from './rw/routes.json';
import rwRental from './rw/rental.json';

import swCommon from './sw/common.json';
import swAuth from './sw/auth.json';
import swBooking from './sw/booking.json';
import swPricing from './sw/pricing.json';
import swValidation from './sw/validation.json';
import swWallet from './sw/wallet.json';
import swNotification from './sw/notification.json';
import swHome from './sw/home.json';
import swRoutes from './sw/routes.json';
import swRental from './sw/rental.json';

import zhCommon from './zh-CN/common.json';
import zhAuth from './zh-CN/auth.json';
import zhBooking from './zh-CN/booking.json';
import zhPricing from './zh-CN/pricing.json';
import zhValidation from './zh-CN/validation.json';
import zhWallet from './zh-CN/wallet.json';
import zhNotification from './zh-CN/notification.json';
import zhHome from './zh-CN/home.json';
import zhRoutes from './zh-CN/routes.json';
import zhRental from './zh-CN/rental.json';

import frCommon from './fr/common.json';
import frAuth from './fr/auth.json';
import frBooking from './fr/booking.json';
import frPricing from './fr/pricing.json';
import frValidation from './fr/validation.json';
import frWallet from './fr/wallet.json';
import frNotification from './fr/notification.json';
import frHome from './fr/home.json';
import frRoutes from './fr/routes.json';
import frRental from './fr/rental.json';

import esCommon from './es/common.json';
import esAuth from './es/auth.json';
import esBooking from './es/booking.json';
import esPricing from './es/pricing.json';
import esValidation from './es/validation.json';
import esWallet from './es/wallet.json';
import esNotification from './es/notification.json';
import esHome from './es/home.json';
import esRoutes from './es/routes.json';
import esRental from './es/rental.json';

/**
 * i18n/index.ts - Section 7 of the spec: en/rw/sw/zh-CN/fr/es, English as
 * the fallback. Each language is split into namespaces (common, auth,
 * booking, pricing, validation, wallet, notification, home, routes, rental)
 * matching Section 7.4's file structure - keeps any one JSON file from
 * becoming an unmanageable wall of unrelated strings.
 *
 * i18next-browser-languagedetector picks a sensible initial language from
 * the browser before the user has chosen one explicitly; AppLanguageSelector
 * (components/navigation) is what lets them override it, and that choice
 * is what LanguageSelector persists for next time.
 */
void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: env.defaultLanguage,
    supportedLngs: [...env.supportedLanguages],
    defaultNS: 'common',
    ns: ['common', 'auth', 'booking', 'pricing', 'validation', 'wallet', 'notification', 'home', 'routes', 'rental'],
    resources: {
      en: {
        common: enCommon,
        auth: enAuth,
        booking: enBooking,
        pricing: enPricing,
        validation: enValidation,
        wallet: enWallet,
        notification: enNotification,
        home: enHome,
        routes: enRoutes,
        rental: enRental,
      },
      rw: {
        common: rwCommon,
        auth: rwAuth,
        booking: rwBooking,
        pricing: rwPricing,
        validation: rwValidation,
        wallet: rwWallet,
        notification: rwNotification,
        home: rwHome,
        routes: rwRoutes,
        rental: rwRental,
      },
      sw: {
        common: swCommon,
        auth: swAuth,
        booking: swBooking,
        pricing: swPricing,
        validation: swValidation,
        wallet: swWallet,
        notification: swNotification,
        home: swHome,
        routes: swRoutes,
        rental: swRental,
      },
      'zh-CN': {
        common: zhCommon,
        auth: zhAuth,
        booking: zhBooking,
        pricing: zhPricing,
        validation: zhValidation,
        wallet: zhWallet,
        notification: zhNotification,
        home: zhHome,
        routes: zhRoutes,
        rental: zhRental,
      },
      fr: {
        common: frCommon,
        auth: frAuth,
        booking: frBooking,
        pricing: frPricing,
        validation: frValidation,
        wallet: frWallet,
        notification: frNotification,
        home: frHome,
        routes: frRoutes,
        rental: frRental,
      },
      es: {
        common: esCommon,
        auth: esAuth,
        booking: esBooking,
        pricing: esPricing,
        validation: esValidation,
        wallet: esWallet,
        notification: esNotification,
        home: esHome,
        routes: esRoutes,
        rental: esRental,
      },
    },
    interpolation: { escapeValue: false }, // React already escapes output
    detection: { order: ['localStorage', 'navigator'], caches: ['localStorage'] },
  });

export default i18n;
